<template>
    <div>
		<hr>
		<div class="sellpo-container" v-for="(point, index) in config" :key="index">
			<div class="title font-weight-bold">#{{ index+1 }}</div>
			<div class="form-group">
				<label for="title">Label</label>
				<input type="text" class="form-control" v-model="point.title" id="title" placeholder="Judul selling point" required>
			</div>
			<div class="form-group">
				<label for="url">Link To</label>
				<input type="text" class="form-control" v-model="point.url_to" id="url" placeholder="Input url for link to selling point" required>
			</div>
			<!-- start upload image area -->
            <div class="form-group">
                <label for="image">Icon</label>
                <button class="btn btn-sm btn-plain text-danger" v-if="point.image_url !== undefined && point.image_url !== ''" @click="point.image_url = ''">
                    <i class="bi-x-circle"></i> Remove Icon
                </button>
                <div class="my-2 text-center preview-image selling-point-icon" v-if="point.image_url !== undefined && point.image_url !== ''">
                    <img class="img-fluid rounded" :src="point.image_url" alt="Uploaded Image">
                </div>
                <div
                    v-if="isUploading && point.image_url === ''"
                    class="pc-image-empty"
                >
                    <div class="image-loading">
                        <div class="is-loading"></div>
                    </div>
                </div>
                <div
                    v-else-if="point.image_url === ''"
                    class="pc-image-empty cursor-pointer"
                    @click="uploadImage(index)"
                >
                    <div class="image-upload-placeholder">
                        <i class="fi fi-rr-picture image-placeholder"></i>
                        <div class="text-placeholder">
                            Klik untuk upload.
                        </div>
                    </div>
                </div>
                <!-- <div class="pc-input-desc">
                    Upload image dengan resolusi 1300x183px agar fit dengan ukuran banner.
                </div> -->
            </div>
            <div class="form-group buttons m-0 hidden">
                <input
                    type="file"
                    accept="image/*"
                    class="input-file"
                    ref="imageUploader"
                    id="pc-product-images-file"
                    @change="onInputImageChange"
                    multiple
                />
                <label
                    for="pc-product-images-file"
                    class="btn btn-primary"
                    :class="{ 'is-loading': isUploading }"
                    >Upload images</label
                >
                <div class="pc-input-desc">
                    Make sure your image resolution is 1296x324 px
                </div>
            </div>
            <!-- end upload image area -->
			<hr v-if="config.length !== index+1">
		</div>
	</div>
</template>
<script>
import mediaApi from '@/api/media';

export default {
	name: 'SellingPoint',
	props: {
		config: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			isUploading: false,
			currentIndexUpload: null,
		};
	},
	methods: {
		uploadImage(index) {
			console.log('up', index);
			this.currentIndexUpload = index;
			const inputFile = this.$refs.imageUploader[index];
			inputFile.click();
		},
		onInputImageChange(event) {
			this.isUploading = true;
			const maxUploadSize = 3; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 3MB)`;
					this.$notify({
						group: 'admin-sliders',
						text: noticeMessage,
						type: 'warn',
					});
					break;
				}

				this.config[this.currentIndexUpload].image_url = '';

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('image', image);

				const callback = (response) => {
					this.isUploading = false;
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;

					this.config[this.currentIndexUpload].image_url = url;
				};

				const errorCallback = (e) => {
					this.isUploading = false;
					console.log(e);
				};

				// Upload Image
				mediaApi.uploadImage(uploadParams, callback, errorCallback);
			}
			event.target.files = null;
			event.target.value = '';
		},
	},
};
</script>
<style lang="scss" scoped>
	label {
		font-weight: 700;
		font-size: 16px;
		line-height: 150%;
	}

	.form-control {
		border: 2px solid #1F1F1F61;
		height: calc(2.3em + 0.75rem + 2px);
	}

	.selling-point-icon {
		max-width: 80px;
	}
</style>
